import { Mask, Spinner, Text } from '@instructure/ui';
import useAppStore from '../../stores/app';

const PageLoader = () => {
  return (
    <>
      {useAppStore.getState().pageLoader.enabled && (
        <Mask
          placement="center"
          fullscreen={true}
          themeOverride={{ zIndex: 9999 }}
        >
          <Spinner renderTitle="Loading" size="large" />
          <Text size="large" color="primary">
            {useAppStore.getState().pageLoader.text}
          </Text>
        </Mask>
      )}
    </>
  );
};

export default PageLoader;
